export default "__VITE_ASSET__9e5bb5b3__"